import { Label, NumberInput, PhoneInput, TextInput } from 'components/Form'
import notification from 'helpers/notification'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import services from 'services/index'

const UpdateForm = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const role = useSelector(state => state?.user?.user?.user_type)
	const [disabled, setDisabled] = useState(false)
	const [updateData, setUpdateData] = useState()
	useEffect(() => {
		const data = location?.state?.updateData
		data && setUpdateData(data)
	}, [location?.state])

	const updateStudent = () => {
		const options = {
			data: updateData,
			onStart: () => setDisabled(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setDisabled(false),
			onSuccess: response => {
				if (response?.status === 200) {
					navigate('/account/students')
					notification("O'quvchi ma'lumotlari muvaffaqiyatli o'zgartirildi!", {
						type: 'success',
					})
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.students.updateStudents(options)
	}
	return (
		<div className='pt-6'>
			<div className='grid grid-cols-12 gap-4 mb-6'>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Ism</Label>
					<TextInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.first_name}
						onChange={first_name =>
							setUpdateData({ ...updateData, first_name })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Familiya</Label>
					<TextInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.last_name}
						onChange={last_name => setUpdateData({ ...updateData, last_name })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Sinf</Label>
					<NumberInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.student_class}
						onChange={student_class =>
							setUpdateData({ ...updateData, student_class })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Otasining telefon raqami</Label>
					<PhoneInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.phone_number}
						onChange={phone_number =>
							setUpdateData({ ...updateData, phone_number })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Onasining telefon raqami</Label>
					<PhoneInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.phone_number2}
						onChange={phone_number2 =>
							setUpdateData({ ...updateData, phone_number2 })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Login</Label>
					<TextInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.username}
						onChange={username => setUpdateData({ ...updateData, username })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Parol</Label>
					<TextInput
						isDisabled={role !== 'admin'}
						size='small'
						value={updateData?.password}
						onChange={password => setUpdateData({ ...updateData, password })}
					/>
				</div>
			</div>
			<div className='flex justify-center sm:justify-end mt-4'>
				{role === 'admin' ? (
					<button
						disabled={disabled}
						className='success-btn w-full sm:w-auto'
						onClick={updateStudent}
					>
						Saqlash
					</button>
				) : (
					<></>
				)}
			</div>
		</div>
	)
}

export default UpdateForm
